import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'octo-terms-dialog',
    templateUrl: './terms-dialog.component.html',
    styleUrls: ['./terms-dialog.component.scss'],
})
export class TermsDialogComponent {
    constructor(
        private modalRef: MatDialogRef<TermsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
}
